import {remote} from '../constants/environment';
import {IStandardServiceResponse} from '../interfaces/services/standard-service.interface';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {defaultHeaders} from './headers';

export const postSendEmailBalance = async (
  id: string,
  code: string,
  token: string,
  isSalesman = false,
): Promise<IStandardServiceResponse> => {
  const remoteURI = remote.getSendBalanceByEmailUri(isSalesman);

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'POST',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
        body: JSON.stringify({
          payload: {
            id,
            type: code,
          },
        }),
      });
    },
    async (response: Response) => {
      if (response.status === 200) {
        const json = await response.json();

        const {success} = json;
        if (success) {
          return {
            success: true,
            payload: {},
          };
        }
      }
    },
    remoteURI,
  )) as IStandardServiceResponse;
};
